import * as React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";
import AuthService from "../../auth/AuthService";
import GoogleButtonHESP from "../GoogleButtonHESP/GoogleButtonHESP";
import styled from "styled-components";

const Wrapper = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
`;

function GoogleComplete() {
    function signInWithGoogle() {
        AuthService.signInWithGoogle();
    }

    return (
        <>
            <SectionTitle title="Google Sign Up complete!" align="center" />
            <Wrapper>
                <p style={{ marginBottom: "40px" }}>
                    We successfully created an organization for your Google account! Please hit the button below to go
                    further.
                </p>
                <GoogleButtonHESP isSignUp={false} onClick={signInWithGoogle} />
            </Wrapper>
        </>
    );
}

export default GoogleComplete;
